import { render, staticRenderFns } from "./regionalEquityMarket.vue?vue&type=template&id=6703ca09&scoped=true"
import script from "./regionalEquityMarket.vue?vue&type=script&lang=js"
export * from "./regionalEquityMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6703ca09",
  null
  
)

export default component.exports